module.exports = __webpack_public_path__ + "static/telekinoBg-4ae58e5d4e9222e8c19aba4562020a19.svg";